const scrollTop = document.getElementById('scroll__top');

if (!scrollTop) {
	console.error('Back to top button not found');
} else {
	scrollTop.addEventListener('click', function () {
		window.scroll({ top: 0, left: 0, behavior: 'smooth' });
	}); // Function to show/hide back to top button
	function toggleBackToTop() {
		const scrollY = window.scrollY || window.pageYOffset;

		if (scrollY > 200) {
			scrollTop.classList.add('active');
		} else {
			scrollTop.classList.remove('active');
		}
	}

	// Check immediately
	toggleBackToTop();

	// Check on scroll
	window.addEventListener('scroll', toggleBackToTop);

	// Check on load
	window.addEventListener('load', toggleBackToTop);
}
